var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as firebase from 'firebase';
export function getAvailableConfigs() {
    return __awaiter(this, void 0, void 0, function () {
        var snapshot, names;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.database().ref().once('value')];
                case 1:
                    snapshot = _a.sent();
                    names = [];
                    snapshot.forEach(function (child) {
                        names.push(child.val().name);
                        return false;
                    });
                    // const configs = snapshot.val();
                    // for (const name in configs) {
                    //   if (configs.hasOwnProperty(name)) {
                    //     names.push(name);
                    //   }
                    // }
                    return [2 /*return*/, names];
            }
        });
    });
}
export function getConfigOld(name, onData) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.database().ref("" + name).on('value', function (snapshot) { return onData(snapshot); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getConfig(name, onData) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            firebase.database().ref().once('value', function (snapshot) {
                snapshot.forEach(function (child) {
                    if (child.val().name === name) {
                        child.child('config').ref.on('value', function (s) { return onData(s); });
                        return true;
                    }
                    return false;
                });
            });
            return [2 /*return*/];
        });
    });
}
export function getLink(ref, onData) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.database().ref("" + ref).on('value', function (snapshot) { return onData(snapshot.val()); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function updateLink(ref, link) {
    firebase.database().ref("" + ref).set(link);
}
export function addLink(ref, link) {
    firebase.database().ref("" + ref).push().set(link);
}
export function addLinkNewRow(ref, link) {
    firebase.database().ref("" + ref).push().push().set(link);
}
export function getRootReference() {
    return firebase.database().ref();
}
export function getReference(ref) {
    return firebase.database().ref(ref);
}



//////////////////
// WEBPACK FOOTER
// ./src/Repository.ts
// module id = 24
// module chunks = 0